import { Box, Text } from '@nimbus-ds/components';
import { DiscountOptionCard } from './DiscountOptionCard';
import { DiscountOptionRow } from './DiscountOptionRow';
import { DiscountOption } from './types';

interface DiscountOptionListProps {
  title: string;
  options: DiscountOption[];
  displayOptionAsCard?: boolean;
}

export function DiscountOptionList({
  title,
  options,
  displayOptionAsCard = true,
}: Readonly<DiscountOptionListProps>): JSX.Element {
  return (
    <Box display="grid" gridTemplateColumns="1fr" gridGap="3">
      <Text fontSize="highlight" color="neutral-textHigh">
        {title}
      </Text>

      {displayOptionAsCard ? (
        options.map((option) => (
          <DiscountOptionCard key={option.id} {...option} />
        ))
      ) : (
        <Box display="flex" flexDirection="column" gap="none">
          {options.map((option, index) => (
            <DiscountOptionRow
              key={option.id}
              {...option}
              isLastOption={index === options.length - 1}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}
